import {Box, Flash} from '@primer/react'

export function WeirichCommitBanner({imageURL}: {imageURL: string}) {
  return (
    <Flash sx={{mb: 4}}>
      <Box
        as="img"
        src={imageURL}
        alt="flower image"
        sx={{width: '88px', height: '49px', mr: 4, mt: 1, float: 'left'}}
      />
      <h2>Thanks for everything, Jim.</h2>
      <p>We will miss you.</p>
    </Flash>
  )
}

try{ WeirichCommitBanner.displayName ||= 'WeirichCommitBanner' } catch {}